export const isCustomerChecklist = name => String(name || '').trim().replace(/\s+/g, ' ').toLowerCase() === 'customer file checklist';

export const documentPresentationVersion = (document, preferred) => isCustomerChecklist(document?.name)
  ? 'v2' : (preferred || document?.defaultDocHubVersion) === 'v1' ? 'v1' : 'v2';

// Retain every visible nonempty cell and its original binding. Only presentation changes:
// spacing cells disappear and neighbouring labels/editors become responsive field cards.
export function checklistRows(cells, isCustomCell = () => false) {
  const rows = new Map();
  cells.forEach(cell => {
    if (!cell.hasText && !cell.isVariable && !cell.isCheckbox && !cell.formula && !isCustomCell(cell)) return;
    if (!rows.has(cell.row0)) rows.set(cell.row0, []);
    rows.get(cell.row0).push(cell);
  });
  const editable = cell => cell.isVariable || cell.isCheckbox || cell.formula || isCustomCell(cell);
  return Array.from(rows, ([row, content]) => {
    const groups = [];
    content.forEach((cell, i) => {
      const last = groups[groups.length - 1];
      if (editable(cell) && !cell.isCheckbox && last?.kind === 'text' && last.cells.length === 1) {
        last.kind = 'field'; last.cells.push(cell);
      } else if (!editable(cell) && last?.kind === 'check' && last.cells.length === 1) {
        last.cells.push(cell);
      } else if (cell.isCheckbox && !content[i + 1] && last?.kind === 'text') {
        last.kind = 'check'; last.cells.unshift(cell);
      } else groups.push({ kind: cell.isCheckbox ? 'check' : editable(cell) ? 'field' : 'text', cells: [cell] });
    });
    return { row, groups };
  });
}
